import { render, staticRenderFns } from "./CetakResepOptik.vue?vue&type=template&id=60cf3153&"
import script from "./CetakResepOptik.vue?vue&type=script&lang=js&"
export * from "./CetakResepOptik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports